<template>
	<div class="page noScroll">
		<div class="page-content review-page-content" style="padding-top: 50px;">
			<ReviewNav :activeIndex="0"></ReviewNav>
			<!-- search -->
			<div class="review-search bg-blue">
				<div class="review-search-item review-search-filter  div--inlineBlock" @click="showFilter(0)">
					<img src="../../assets/review-filter.png">
					<span>筛选</span>
				</div>
				<div class="review-search-item review-search-order div--inlineBlock" @click="showFilter(1)">
					<img src="../../assets/review-seq.png">
					<span>排序</span>
				</div>
				<router-link tag="div" to="/Rccl.Review/ReviewPicture/OwnPicture" class="review-search-item review-search-order div--inlineBlock review-showMyPic">
					<img src="../../assets/showPicIcon.png">
					<span>显示我秀的美图</span>
				</router-link>
			</div>
			<div class="page-content bg-white" id="reviewPicture" ref="listContent">
				<div class="review-list bg-white scroll-container" id="review-list" ref="reviewListContent">
					<div class="review-list-tips border-grey">
						<div v-html="reviewPicTitle"></div>
					</div>
					<div class="review-list-content bg-white" >
						<router-link tag="div" class="review-list-item external" v-for="(item, index) in reviewList" :to="`/Rccl.Review/ReviewPicture/Detail?reviewPicId=${item.id}`" :key="index">
							<div class="review-item-imgInfo">
								<div class="review-item-img">
									<img :src="item.titleImage" alt="titleImg">
								</div>
								<div class="review-item-imgName">{{item.content}}</div>
							</div>
							<div class="review-item-text">
								<div class="review-item-username">
									<img src="https://resource.rcclchina.com.cn/logo/MB/logoAvatarCircleBlueLarge.png" alt="logo">
									<span>{{item.nickname}}</span>
								</div>
								<UpVote :isUpVote="item.isUpvote"
                                        :score="item.score"
                                        @on-upVote="upVote(item, index)"></UpVote>
							</div>
						</router-link>

					</div>
					<div v-if="reviewList.length==0">
						<span slot="no-more"></span>
						<div class="review-list-nodata" slot="no-results">
							<p>暂无数据</p>
							<a href="/Rccl.Review/ReviewPicture/Index" class="external">查看全部美图</a>
						</div>
					</div>
				</div>
			</div>
			<!-- filter/sort -->
			<div class="review-search-content" v-if="isShowFilter">
				<div class="review-search-bg bg-cover"></div>
				<div class="review-search-nav bg-blue">
					<div class="review-search-cancel div--inlineBlock" @click="closeFilter">取消</div>
					<div class="review-search-clear div--inlineBlock" @click="clearFilter">清空筛选</div>
					<div class="review-search-confirm div--inlineBlock" @click="changeCondition">确认</div>
				</div>
				<div class="review-search-select bg-white">
					<div v-if="showType === 0">
						<div class="review-search-tags">
							<div class="review-search-item-title">图片分类</div>
							<div class="review-search-items">
								<div class="review-search-item div--inlineBlock" v-bind:class="{active: tags === ''}" @click="changeTags('')"><span>不限</span></div>
								<div class="review-search-item div--inlineBlock" v-for="item in tagsList" :key="item.id" v-bind:class="{active: tags === item.title}" @click="changeTags(item.title)"><span>{{item.title}}</span></div>
							</div>
						</div>
						<div class="review-search-shipCode">
							<div class="review-search-item-title">游轮名称</div>
							<div class="review-search-items">
								<div class="review-search-item div--inlineBlock" v-bind:class="{active: shipCode === ''}" @click="changeShipCode('')"><span>不限</span></div>
								<div class="review-search-item div--inlineBlock" v-for="(item, index) in shipList" :key="index" v-bind:class="{active: shipCode === item.shipCode}" @click="changeShipCode(item.shipCode)"><span>{{item.shipCNName}}</span></div>
							</div>
						</div>
					</div>
					<div class="review-search-filter-content" v-if="showType === 1">
						<!--1time升序 0time降序(默认) 5发布时间升序 6发布时间降序 10点赞数降序 11点赞数升序-->
						<div v-bind:class="{arrowUpB: orderBySailDate === 1}" @click="changeSort({orderBySailDate})">
							<span>出行时间</span>
							<img src="../../assets/gray_arrow.png" alt="" v-if="orderBySailDate === 0">
							<img src="../../assets/blue_arrow.png" alt="" v-else>
						</div>
						<div v-bind:class="{arrowUpB: orderByCreateDate === 1}" @click="changeSort({orderByCreateDate})">
							<span>发布时间</span>
							<img src="../../assets/gray_arrow.png" alt="" v-if="orderByCreateDate === 0">
							<img src="../../assets/blue_arrow.png" alt="" v-else>
						</div>
						<div v-bind:class="{arrowUpB: orderByPraiseNum === 1}" @click="changeSort({orderByPraiseNum})">
							<span>点赞数</span>
							<img src="../../assets/gray_arrow.png" alt="" v-if="orderByPraiseNum === 0">
							<img src="../../assets/blue_arrow.png" alt="" v-else>
						</div>
					</div>
				</div>
			</div>
			<!-- upload pic -->
			<UploadPic></UploadPic>
		</div>
	</div>
</template>

<script>
	import api from '@/api'
	import ReviewNav from '@/components/Review/ReviewNav.vue'
	import UpVote from '@/components/Review/UpVote.vue'
	import UploadPic from '@/components/Review/UploadPic.vue'
	export default {
		name: 'ReviewIndex',
		components: {
			ReviewNav,
			UpVote,
			UploadPic
		},
		data () {
			return {
				userToken: '',
				reviewList: [],
				tagsList: [],
				shipList: [],
                reviewPicTitle: "",
				thisIdentifier: +Date.now(),
				pageNum: 0,
				pageSize: 10,
				shipCode: '',
				sailDate: '',
				tags: '',
				orderBySailDate: 0,
				orderByCreateDate: 2,
				orderByPraiseNum: 0,
				temporaryShipCode: '',
				temporarySailDate: '',
				temporaryTags: '',
				temporaryOrderBySailDate: 0,
				temporaryOrderByCreateDate: 0,
				temporaryOrderByPraiseNum: 0,
				isShowFilter: false,
				isLoadingReview: false,
				showType: 0 // 0 过滤  1 排序
			}
		},
		beforeMount () {
			this.$store.commit('SET_PAGE_TITLE', '秀美图')
			this.showPage()
		},
		mounted () {
			this.$refs.listContent.addEventListener('scroll', this.onListScrollHander)
		},
		beforeDestroy () {
			this.$refs.listContent.removeEventListener('scroll', this.onListScrollHander)
		},
		methods: {
			async showPage () {
				this.$loading.show()
				await this.initPage()
				this.$loading.hide()
				await this.infiniteHandler()
			},
			async initPage () {
				this.userToken = this.$store.state.user.userToken

				const data = await this.getReviewPicsFilter()
				this.tagsList = data.tags
				this.shipList = data.ships
                this.reviewPicTitle = data.reviewPicTitle
			},
			async infiniteHandler () {
				this.$loading.show()
				this.isLoadingReview = true
				const data = await this.getReviewPics({
					Offset: this.pageNum * this.pageSize,
					Limit: this.pageSize,
					ShipCode: this.shipCode,
					SailDate: this.sailDate,
					Tags: this.tags,
					OrderBySailDate: this.orderBySailDate,
					OrderByCreateDate: this.orderByCreateDate,
					OrderByPraiseNum: this.orderByPraiseNum
				})
				this.isLoadingReview = false
				this.$loading.hide()
				if (data.length > 0) {
					this.reviewList = [...this.reviewList, ...data]
					this.pageNum++
					// $state.loaded()
				} else {
					// $state.complete()
				}

			},
			async getReviewPics (requestData) {
				const {success, data, errMsg} = await api.review.getReviewPics(requestData)
				if (!success) {
					console.log(errMsg)
					return null
				} else {
					return data.rpData
				}
			},
			async upVote (item, index) {
				if(!this.userToken) {
					this.$alert.show('请先登录', {
						confirmCallBack: ()=> {
							this.$router.push({ name: 'Login', query:{
								returnUrl: location.href
							}})
						}
					})
					return false
				}
				this.$loading.show()
				const {success, errMsg} = await api.review.upVotePic({userName: this.userToken, reviewPicId: item.id})
				if (!success) {
					this.$alert.show(errMsg)
				} else {
					// console.log(data)
					this.reviewList[index].isUpvote = true
					this.reviewList[index].score++
				}
				this.$loading.hide()
			},
			showFilter (flag) {
				this.isShowFilter = true
				this.showType = flag
				this.temporaryShipCode = this.shipCode
				this.temporaryTags = this.tags
				this.temporaryOrderBySailDate = this.orderBySailDate
				this.temporaryOrderByCreateDate = this.orderByCreateDate
				this.temporaryOrderByPraiseNum = this.orderByPraiseNum
			},
			closeFilter () {
				this.isShowFilter = false
				this.shipCode = this.temporaryShipCode
				this.tags = this.temporaryTags
				this.orderBySailDate = this.temporaryOrderBySailDate
				this.orderByCreateDate = this.temporaryOrderByCreateDate
				this.orderByPraiseNum = this.temporaryOrderByPraiseNum
			},
			clearFilter () {
				this.temporaryShipCode = ''
				switch (this.showType) {
					case 0:
						this.shipCode = ''
						this.tags = ''
						break
					case 1:
						this.orderBySailDate = 0
						this.orderByCreateDate = 0
						this.orderByPraiseNum = 0
						break
				}
			},
			changeCondition () {
				this.pageNum = 0
				this.reviewList = []
				this.thisIdentifier = +Date.now()
				this.isShowFilter = false
				this.infiniteHandler()
			},
			changeTags (tags) {
				this.tags = tags
			},
			changeShipCode (shipCode) {
				this.shipCode = shipCode
			},
			changeSort (obj) {
				this.orderBySailDate = 0
				this.orderByCreateDate = 0
				this.orderByPraiseNum = 0
				if (obj.orderBySailDate === 0) {
					this.orderBySailDate = 1
				} else if (obj.orderBySailDate === 1) {
					this.orderBySailDate = 2
				} else if (obj.orderBySailDate === 2) {
					this.orderBySailDate = 1
				}
				if (obj.orderByCreateDate === 0) {
					this.orderByCreateDate = 1
				} else if (obj.orderByCreateDate === 1) {
					this.orderByCreateDate = 2
				} else if (obj.orderByCreateDate === 2) {
					this.orderByCreateDate = 1
				}
				if (obj.orderByPraiseNum === 0) {
					this.orderByPraiseNum = 1
				} else if (obj.orderByPraiseNum === 1) {
					this.orderByPraiseNum = 2
				} else if (obj.orderByPraiseNum === 2) {
					this.orderByPraiseNum = 1
				}
			},
			async getReviewPicsFilter (requestData) {
				const {success, data, errMsg} = await api.review.getReviewPicsFilter(requestData)
				if (!success) {
					this.$alert.show(errMsg)
				} else {
					return data
				}
			},
			onListScrollHander (e) {
				const target = e.target
				if (target.scrollTop >= this.$refs.reviewListContent.offsetHeight - target.offsetHeight && !this.isLoadingReview) {
					this.infiniteHandler()
				}
			}
		}
	}
</script>

<style scoped>
	.page {
		display: block;
		background: #F6F7F8 !important;
	}
	.review-page-content {
		overflow: hidden;
	}
	/**** search ****/
	.review-search {
		width:100%;
		height: 36px;
		font-size: 12px;
		color: white;
		line-height: 36px;
	}
	.review-search .redDot {
		position: absolute;
		left: 87px;
		top: 2px;
		width: 6px;
		height: 6px;
		border-radius: 3px;
		background-color: #f00;
	}
	.review-search .review-search-item {
		width: 33.333333%;
		text-align: center;
		position: relative;
	}
	.review-search .review-search-item span{
		color: #fff;
	}
	.review-search .review-search-filter img {
		width: 15px;
		height: 20px;
		position: relative;
		top: 4px;
		margin-right: 12px;
	}
	.review-search .review-search-order img {
		width: 18px;
		height: 18px;
		position: relative;
		top: 4px;
		margin-right: 12px;
	}
	/****===== list =====****/
	.review-list {
		padding-bottom: 50px;
	}
	.review-list-tips {
		min-height: 85px;
		font-size: 12px;
		text-align:center;
		display:flex;
		flex-direction:column;
		-webkit-flex-direction:column;
		justify-content:center;
	}

	.review-list-tips img {
		width: 100%;
		height: auto;
	}

	.review-list-tips a {
		display: block;
	}

	.review-list-tips p{
		font-size:12px;
		margin:0;
	}
	.review-list-nodata {
		font-size: 13px;
		color: #061556;
		text-align:center;
		font-weight:bold;
	}
	.review-list-nodata>p{
		margin:0;
	}
	.review-list-nodata>a{
		display:block;
		font-size:14px;
		background-color:#f0af11;
		color:#fff;
		border-radius:12px;
		width:150px;
		height:24px;
		line-height:24px;
		margin:0 auto;
	}
	.review-list-content {
		padding: 9px 12px 70px 12px;
		overflow: hidden;
		border-top: 1px solid #e0e0e0;
	}
	.review-list-item {
		float: left;
		width: 172px;
		margin-bottom: 14px;
		padding: 6px;
		border: 1px solid #f5f4f4;
	}
	.review-list-item:nth-child(2n+1) {
		margin-right:6px;
	}
	.review-item-imgInfo {
		width:100%;
		position:relative;
	}
	.review-item-imgInfo .review-item-img {
		width:100%;
		height:117px;
		overflow:hidden;
	}
	.review-item-imgInfo .review-item-img img{
		position:relative;
		left:50%;
		top:50%;
		transform:translate(-50%,-50%);
		-webkit-transform:translate(-50%,-50%);
		-moz-transform:translate(-50%,-50%);
		-o-transform:translate(-50%,-50%);
		-ms-transform:translate(-50%,-50%);
		max-width:100%;
		max-height:100%;
	}
	.review-item-imgInfo .review-item-imgName {
		width:100%;
		height:30px;
		line-height:30px;
		background-color:rgba(0,0,0,.5);
		color:#fff;
		font-size:12px;
		padding-left:10px;
		position:absolute;
		bottom:0;
		left:0;
		overflow:hidden;
		text-overflow:ellipsis;
		white-space:nowrap;
	}
	.review-item-text {
		margin-top:5px;
		overflow:hidden;
		font-size:0;
	}
	.review-item-text .review-item-username{
		float:left;
		margin-left:7px;
	}
	.review-item-text .review-item-username img{
		width:22px;
		height:22px;
		vertical-align:middle;
	}
	.review-item-text .review-item-username span {
		display:inline-block;
		width:58px;
		white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis;
		color: #666;
		font-size: 12px;
		margin-left: 7px;
		vertical-align: middle;
	}
	.review-item-like{
		margin-right: 13px;
	}

	/**** 筛选/排序 ****/
	.review-search-content {
		position: absolute;
		width: 100%;
		top: 50px;
		z-index: 11;
		height: 100%;
	}
	.review-search-bg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
	}
	.review-search-filter-content > div {
		border-top: 1px solid #eee;
		height: 35px;
		line-height: 35px;
		text-align: center;
		color: #666;
		position: relative;
		font-size: 13px;
	}
	.review-search-filter-content > div>span {
		display:inline-block;
		width:107px;
	}
	.review-search-filter-content > div.arrowUpB > img {
		transform: rotate(180deg);
		-ms-transform: rotate(180deg); /* Internet Explorer */
		-moz-transform: rotate(180deg); /* Firefox */
		-webkit-transform: rotate(180deg); /* Safari 和 Chrome */
		-o-transform: rotate(180deg); /* Opera */
	}
	.review-search-filter-content > div.active {
		color: #061556;
	}
	.review-search-filter-content > div i {
		color: #f0af11;
		font-size: 18px;
		visibility: hidden;
		position: absolute;
		right: 29px;
		top: 6px;
	}
	.review-search-filter-content > div.active i {
		visibility: visible;
	}
	.review-search-content .review-search-select {
		position: relative;
		max-height:400px;
		overflow-y:auto;
	}
	.review-search-content .review-search-nav {
		color: white;
		font-size: 13px;
		height: 36px;
		line-height: 36px;
		padding: 0px 20px;
		position: relative;
	}
	.review-search-content .review-search-confirm {
		position: absolute;
		top: 1px;
		right: 20px;

	}
	.review-search-content .review-search-cancel {
		position: absolute;
		top: 1px;
		left: 20px;
	}
	.review-search-content .review-search-clear {
		border-radius: 5px;
		height: 28px;
		line-height: 28px;
		padding: 0px 5px;
		border: 1px solid white;
		position: absolute;
		top: 4px;
		left: 155px;
	}
	.review-search-content .review-search-destination {
		border-bottom: 1px dotted #ccc;
	}
	.review-search-content .review-search-item-title {
		color: #061556;
		font-size: 14px;
		padding: 10px;
		font-weight: bold;
	}
	.review-search-content .review-search-items {
		margin: 5px 10px;
		font-size: 13px;
	}
	.review-search-content .review-search-items .active span {
		background-color: #061556;
		color: white;
		border-radius: 8px;
	}
	.review-search-content .review-search-item {
		text-align: center;
		margin-bottom: 6px;
	}
	.review-search-ship .review-search-item:first-child {
		width: 19%;
	}
	.review-search-ship .review-search-item {
		width:25%;
	}
	.review-search-content .review-search-item span {
		display: inline-block;
		padding: 5px 8px;
	}
</style>
